import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom Link
import './index.css'; // Assuming styles are in src/index.css

const Home = () => {
  return (
    <div className="app-container">
      <header className="main-header">
        {/* Breadcrumb can be simplified or removed for the home page */}
        <h1>羽田空港 フライト情報ダッシュボード</h1>
        <nav className="main-nav">
          <Link to="/home" className="active">ホーム</Link>
          <Link to="/domestic">国内線</Link>
          <Link to="/international">国際線</Link>
        </nav>
      </header>
      <div className="container home-container">
        <div className="welcome-section">
          <h2>ようこそ！</h2>
          <p>
            このダッシュボードでは、羽田空港の国内線および国際線のフライト情報をリアルタイムで確認できます。
            スクレイピング技術を使用して、常に最新の情報をお届けします。
          </p>
        </div>

        <div className="feature-cards">
          <div className="feature-card">
            <div className="feature-icon domestic">
              <i className="fas fa-plane"></i>
            </div>
            <h3>国内線情報</h3>
            <p>
              羽田空港の国内線到着便情報を乗り場別に表示します。
              30分毎のフライト数の統計やターミナル・ゲート情報を確認できます。
            </p>
            <Link to="/domestic" className="nav-button">国内線情報を見る</Link>
          </div>

          <div className="feature-card">
            <div className="feature-icon international">
              <i className="fas fa-globe"></i>
            </div>
            <h3>国際線情報</h3>
            <p>
              羽田空港の国際線到着便情報をターミナル別に表示します。
              1時間毎のフライト数の統計やゲート情報を確認できます。
            </p>
            <Link to="/international" className="nav-button">国際線情報を見る</Link>
          </div>
        </div>
      </div>
      <footer className="main-footer">
        <p>&copy; {new Date().getFullYear()} 羽田空港フライト情報ダッシュボード</p>
      </footer>
    </div>
  );
};

export default Home;
